import { render, staticRenderFns } from "./WallChart.vue?vue&type=template&id=41812577"
import script from "./WallChart.vue?vue&type=script&lang=js"
export * from "./WallChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports